'use client';

import { SkipLinksContent } from '@coolblue-development/freddy';
import { PropsWithChildren } from 'react';

import { SKIP_LINK_IDS } from './constants';

type Props = PropsWithChildren & {
  id?: string;
};

const Content = ({ id, children }: Props) => {
  return <SkipLinksContent id={id ?? SKIP_LINK_IDS.MAIN_CONTENT}>{children}</SkipLinksContent>;
};

export default Content;
